<template>
	<validation-provider
			:name="'AdminTextarea-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			mode="lazy"
			v-slot="{ errors }">
		<v-textarea
				v-model="$store.state.admin.input[inputItemKey]"
				:disabled="contents[contentKey].inputItems[inputItemKey].disabled"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminTextarea',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		}
	}
</script>

<style scoped>
</style>
